import { render, staticRenderFns } from "./FocusAreaForm.vue?vue&type=template&id=43743df2&"
import script from "./FocusAreaForm.vue?vue&type=script&lang=js&"
export * from "./FocusAreaForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports